import React from 'react'
import { Link } from 'react-router-dom'
import { TABS, count } from './model'

// The three tabs under the aggregates, plus a way out to the intake
// rejections screen. Those submissions never became leads, so they are not
// a tab here and never part of any count on this page.
export default function LeadTabs({ active, counts, onChange }) {
  const onKeyDown = (e) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return
    const i = TABS.findIndex((t) => t.id === active)
    const next = TABS[(i + (e.key === 'ArrowRight' ? 1 : TABS.length - 1)) % TABS.length]
    onChange(next.id)
    document.getElementById(`sl-tab-${next.id}`)?.focus()
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '0 12px', borderBottom: '1px solid var(--border)' }}>
      <div className="sl-tabs" role="tablist" aria-label="Leads by outcome" onKeyDown={onKeyDown} style={{ display: 'flex', minWidth: 0 }}>
        {TABS.map((t) => {
          const selected = active === t.id
          return (
            <button
              key={t.id}
              id={`sl-tab-${t.id}`}
              type="button"
              role="tab"
              className="sl-tab"
              aria-selected={selected}
              aria-controls="sl-tab-panel"
              tabIndex={selected ? 0 : -1}
              onClick={() => onChange(t.id)}
            >
              {t.label}
              <span style={{ marginLeft: 6, fontSize: 11, fontWeight: 600, padding: '1px 7px', borderRadius: 999, background: 'var(--bg-raised)', color: 'var(--text-secondary)' }}>
                {count(counts[t.id])}
              </span>
            </button>
          )
        })}
      </div>
      <Link to="/rejected-submissions" style={{ fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap', textDecoration: 'none', padding: '8px 0' }}>
        Blocked at intake →
      </Link>
    </div>
  )
}
